<div class="container">
  <div class="logout-area">
    <coin-anim-icon
      class="check-icon"
      svgIcon="logout"
      [delay]="500"
      [loop]="false"
      [autoplay]="true"></coin-anim-icon>
    <h2>{{ 'log-out.successfull-logout' | translate }}</h2>
    <coin-v2-button
      class="aa-btn"
      [type]="'primary'"
      [icon]="'skip_previous'"
      [text]="'log-out.re-login' | translate"
      (click)="login()"></coin-v2-button>
  </div>
</div>
